import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import globals from '../globals'
import ReactModal from '../modules/ReactModal'

const options = {
    postUrl: '/api/postCancelService/homeSecure',
    success: 'Your service has been scheduled for cancellation.',
    dontScrollToNav: true
}
const state = {
    serviceId: ''
}

const CancelHomeSecureSubscriptionForm = (props) => {
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        props.setDynamicValues({
            serviceId: props.serviceId
        })
    }, [props.subscriptionEnds])

    const handleCancel = (event) => {
        event.preventDefault()
        setShowModal(false)
    }

    const handleShowModal = (event) => {
        event.preventDefault()
        setShowModal(true)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        setShowModal(false)
        props.handleSubmit()
    }

    const CancelForm = (
        <form onSubmit={handleShowModal} onKeyDown={props.handleKeyDown} className='d-flex align-items-center flex-column flex-lg-row'>
            <div className='mr-lg-4 text-center text-lg-left'>Your Home Secure subscription ends on</div>
            <InputRowReadOnly value={props.subscriptionEnds} />
            <Button title='Cancel subscription' action={handleShowModal} color='red' />
            {props.children}
        </form>
    )

    const TrialForm = (
        <form onSubmit={handleShowModal} onKeyDown={props.handleKeyDown} className='d-flex align-items-center flex-column flex-lg-row'>
            <Button title='Cancel trial' action={handleShowModal} color='red' />
            {props.children}
        </form>
    )

    const AlreadyCancelled = (
        <div className='row-error text-center'>
            <p className='m-0 mb-2 font-medium'>Cancellation underway</p>
            <p className='m-0' dangerouslySetInnerHTML={{ __html: globals.noWidows(`Your service has been scheduled for cancellation and will end on ${props.subscriptionEnds}.`) }} />
        </div>
    )

    return (
        <React.Fragment>
            {props.isCancelled ? AlreadyCancelled : props.isTrial ? TrialForm : CancelForm}
            <ReactModal showModal={showModal} handleCloseModal={() => setShowModal(false)} heading='Just checking'>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <p className='mt-0 mb-4 lh'>Please confirm you would like to cancel Home Secure?</p>
                        <div className='d-flex justify-content-center'>
                            <Button title='Confirm' action={handleSubmit} className='mr-3' />
                            <Button title='Cancel' action={handleCancel} color='red' />
                        </div>
                    </div>
                    {props.children}
                </div>
            </ReactModal>
        </React.Fragment>
    )
}

CancelHomeSecureSubscriptionForm.propTypes = {
    subscriptionEnds: PropTypes.string.isRequired,
    serviceId: PropTypes.number.isRequired,
    isCancelled: PropTypes.bool,
    isTrial: PropTypes.bool
}

export default FormHOC(CancelHomeSecureSubscriptionForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/CancelHomeSecureSubscriptionForm.js